import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data"]

import { ref, onMounted, watchEffect, onUnmounted } from "vue";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4chart from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Array,
    default: () => [] as any[],
  },
},
  setup(__props) {

const props = __props



const chartRef = ref<any>(null);

onMounted(() => {
  am4core.useTheme(am4themes_animated);
  const chart = am4core.create(chartRef.value, am4chart.PieChart);

  const pieSeries = chart.series.push(new am4chart.PieSeries());
  pieSeries.dataFields.value = "value";
  pieSeries.dataFields.category = "status";
  pieSeries.innerRadius = am4core.percent(80);
  pieSeries.ticks.template.disabled = true;
  pieSeries.labels.template.disabled = true;
  pieSeries.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
  pieSeries.legendSettings.labelText = "[bold {color}]{name}[/bold]";
  pieSeries.slices.template.tooltipText = "[bold]{status} : {value}[/bold]";
  pieSeries.slices.template.strokeWidth = 1;
  pieSeries.slices.template.strokeOpacity = 1;
  pieSeries.slices.template.fillOpacity = 1;
  pieSeries.slices.template.propertyFields.fill = "color";

  const hs = pieSeries.slices.template.states.getKey("hover");
  if (hs) {
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.6;
  }

  const as = pieSeries.slices.template.states.getKey("active");
  if (as) {
    as.properties.shiftRadius = 0;
  }

  chart.legend = new am4chart.Legend();
  chart.legend.position = "absolute";
  chart.legend.itemContainers.template.width = 66;
  chart.legend.valueLabels.template.align = "center";
  chart.legend.valueLabels.template.textAlign = "start";
  chart.legend.itemContainers.template.clickable = false;
  chart.legend.itemContainers.template.focusable = false;
  chart.legend.itemContainers.template.cursorOverStyle =
    am4core.MouseCursorStyle.default;

  const markerTemplate = chart.legend.markers.template;
  markerTemplate.width = 16;
  markerTemplate.height = 3;

  chart.data = [...props.data];

  watchEffect(() => {
    if (props.data) {
      chart.data = [...props.data];
    }
  });

  onUnmounted(async () => {
    chart.dispose();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dashboardChart",
    ref_key: "chartRef",
    ref: chartRef,
    data: props.data
  }, null, 8, _hoisted_1))
}
}

})